import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { TryoutMemberService } from '../../../../../services/tryout_Services/tryout-member.service';
import { TryoutProgramService } from '../../../../../services/tryout_Services/tryout-program.service';
import { AlertService } from '../../../../../services';

@Component({
  selector: 'app-tryout-member-info',
  templateUrl: './tryout-member-info.component.html',
  styleUrls: ['./tryout-member-info.component.css']
})
export class TryoutMemberInfoComponent implements OnInit, OnChanges {
  @Input() TryoutMemberID: number;
  @Input() TryoutMemberstatus: string;
  @Input() MemberDetail;
  @Input() invitationHistoryData;

  @Output() getQuestionsEvent = new EventEmitter();
  @Output() closeSideOverlayEvent = new EventEmitter();
  @Output() showfee = new EventEmitter();
  @Output() viewDocument = new EventEmitter();

  fees = [];

  currentUrl = '';
  routeParams;
  payment_status: string = '0';
  DateYear: string;

  constructor(
    private activeRoute: ActivatedRoute,
    private spinnerService: Ng4LoadingSpinnerService,
    private tryoutMemberService: TryoutMemberService,
    private tryoutProgramService: TryoutProgramService,
    private alertService: AlertService) {
    this.routeParams = this.activeRoute.snapshot.params;
  }

  ngOnInit() {
  }

  ngOnChanges(data) {
    if (data.TryoutMemberID) {
      this.getFees();
    }
  }

  getFees() {
    const UserID = this.TryoutMemberID.toString();
    this.tryoutMemberService.getTryoutFees(UserID, this.routeParams.id).subscribe(rs => {
      this.fees = rs;
      this.spinnerService.hide();
    });
  }

  checkPaymentStatus(PStatus) {
    if (PStatus) {
      PStatus = PStatus.toUpperCase();
      if (PStatus.includes('INVITATION SENT')) {
        this.payment_status = '0';
      } else if (PStatus.includes('ACCEPTED')) {
        this.payment_status = '1';
      } else if (PStatus.includes('DECLINED')) {
        this.payment_status = '2';
      } else if (PStatus.includes('SIGNED UP')) {
        this.payment_status = '3';
      } else if (PStatus.includes('PENDING')) {
        this.payment_status = null;
      }
    }
    return true;
  }

  reSendInvite(inviteID, clubUserProgramFeeID) {
    this.spinnerService.show();
    const clubID = +localStorage.getItem('clubId'); // from which club was the request sent
    this.tryoutProgramService.resendInvite(inviteID, this.routeParams.id, clubID, clubUserProgramFeeID).subscribe(rs => {
      console.log('Invite Sent');
      this.alertService.success(rs);
      this.closeSideOverlayEvent.emit();
      this.spinnerService.hide();
    }, error => {
      this.spinnerService.hide();
      this.alertService.error(error.statusText);
    });
  }

  showFeeInfo(fee) {
    this.showfee.emit(fee);
  }

  deleteFee(fee) {
    this.spinnerService.show();
    this.tryoutMemberService.deleteFee(fee.clubUserProgramFeeID).subscribe(() => {
      this.getFees();
    });
  }

  onViewDocument(url) {
    this.viewDocument.emit(url);
  }

}



// WEBPACK FOOTER //
// ./src/app/tryout/pages/tryout-members/partial/tryout-member-info/tryout-member-info.component.ts